import React from "react";
import { motion } from "framer-motion";
import { fadeInUp, staggerContainer, viewportOnce } from "../motionVariants";

// Same skills listed on Shashank's resume, regrouped into the categories
// recruiters scan for: Frontend / Backend / AI-LLM / Database / Cloud & DevOps.
const techCategories = [
    {
        label: "Frontend",
        items: ["React", "Next.js", "React Native (Expo)", "TypeScript", "JavaScript", "Tailwind CSS"],
    },
    {
        label: "Backend",
        items: ["Node.js", "Express", "FastAPI", "Go", "C#", ".NET Core", "Python", "REST APIs", "Microservices"],
    },
    {
        label: "AI / LLM",
        items: [
            "LangGraph", "LangChain", "Multi-Agent Systems", "MCP",
            "OpenAI API", "RAG", "Sentence-Transformers", "AWS Bedrock AgentCore",
        ],
    },
    {
        label: "Database",
        items: ["PostgreSQL", "MongoDB", "Redis", "ChromaDB", "MySQL"],
    },
    {
        label: "Cloud / DevOps",
        items: ["Docker", "Azure", "Claude", "Cursor", "Codex"],
    },
];

export default function TechStack() {
    return (
        <section id="techStackRoot">
            <div className="sectionHead">
                <span className="eyebrow">Skills</span>
                <h2 className="sectionTitle">Toolkit</h2>
            </div>
            <div id="techStackCategories">
                {techCategories.map((category) => (
                    <div className="techCategory" key={category.label}>
                        <h3 className="techCategoryLabel">{category.label}</h3>
                        <motion.div
                            className="techStackGrid"
                            variants={staggerContainer}
                            initial="hidden"
                            whileInView="visible"
                            viewport={viewportOnce}
                        >
                            {category.items.map((tech) => (
                                <motion.span
                                    key={tech}
                                    className="techPill"
                                    variants={fadeInUp}
                                >
                                    {tech}
                                </motion.span>
                            ))}
                        </motion.div>
                    </div>
                ))}
            </div>
        </section>
    );
}
